export default __webpack_public_path__ + "static/media/by_3.ccb829da.mp3";